import Link from "next/link";
import Head from "next/head";
import { useRouter } from "next/router";
import containerStyles from "@ui-kit/Container/Container.module.scss";
import { usePageRecovery } from "@hooks/usePageRecovery";
import s from "./ServerError.module.scss";
import i from "@styles/icons.module.scss";
import { getServerErrorMessages } from "./messages";

const ServerError = ({ statusCode = 500, autoRetry = true }) => {
  const { locale } = useRouter();
  const { retry, canRetry } = usePageRecovery(autoRetry);
  const messages = getServerErrorMessages(locale);
  const title = statusCode === 504 ? messages.timeoutTitle : messages.title;

  return (
    <div className={s.serverError}>
      <Head>
        <title>{title} | Lux Express</title>
      </Head>
      <div className={s.greyBlock} />
      <main className={containerStyles.container}>
        <section>
          <div className={s.content}>
            <h1 className={s.title}>{title}</h1>
            <p>{messages.description}</p>
            {autoRetry && canRetry && <p>{messages.recovery}</p>}
            {canRetry && (
              <button type="button" className={s.retry} onClick={retry}>
                {messages.retry}
              </button>
            )}
            <Link href="/" className={s.toHome}>
              {messages.home}
              <icon className={i.arrowRight_v2} />
            </Link>
          </div>
          <div className={s.code}>{String(statusCode).split("").join(" ")}</div>
        </section>
      </main>
    </div>
  );
};

export default ServerError;
